import modal from './modal'
import pubNotice from './notice'
import tabs from './tabs/index.vue'
export default {
  install: function(Vue) {
    Vue.component('modal', modal)
    Vue.component('pubNotice', pubNotice)
    Vue.component('tabs', tabs)
  }
}


// WEBPACK FOOTER //
// ./src/components/index.js